import { Row, Col } from 'react-bootstrap';
import FirebreakScreenshot1 from "../../../images/Firebreak/firebreak_screenshot_1.png";
import FirebreakScreenshot2 from "../../../images/Firebreak/firebreak_screenshot_2.png";
import FirebreakScreenshot3 from "../../../images/Firebreak/firebreak_screenshot_3.png";
import FirebreakLogo from "../../../images/Firebreak/firebreak_logo.svg";
import FirebreakLogoHorizontal from "../../../images/Firebreak/firebreak_logo_horizontal.svg";
import FirebreakBricksSmall from "../../../images/Firebreak/firebreak_bricks_small.svg";
import "./Firebreak.css";

const Firebreak = () => {

    return (
        <>
            <img 
                src={FirebreakBricksSmall} 
                className="firebreakBricksTop"
                alt="firebreak bricks mobile header"
            />
            <Row>
                <Col lg="5" className="firebreakTextCol">
                    <div className="modalTextLeft firebreakScrolling">
                        <h3 className="modalHeader">FIREBREAK</h3>
                        <div className="firebreakMobileLogo">
                            <img src={FirebreakLogoHorizontal} className="firebreakSmallLogo" alt="firebreak small logo" />
                        </div>
                        <p className="modalSubHeader">CHALLENGE</p>
                        <p>
                           Wildfire risk has shifted from a distant possibility to a present threat for many homeowners. FireBreak’s mission was to make readiness simple and credible: guide a quick self-inspection, quantify a clear risk score, and surface the top three fixes that move the needle most—all in a consumer-friendly experience people would actually use and share. The solution also needed to produce outputs that insurance stakeholders could work with, without lengthy third-party inspections or scheduling delays. 
                        </p>
                        <p className="modalSubHeader">APPROACH</p>
                        <p>
                            We designed a calm, step-by-step iOS flow that asks residents to walk their property, snap targeted photos, and answer focused prompts. In minutes, the app translates those inputs into a risk score and a prioritized action plan—emphasizing the top 3 actions and the most economical ways to reduce exposure. Recommendations are illustrated and written in accessible language so next steps are unambiguous. The finished report is built to be shared—with neighbors, local fire departments, and insurance carriers—turning an individual checklist into a community-level readiness nudge. 
                        </p>
                        <p>
                            To complement the homeowner experience, we shaped the outputs to be insurer-friendly: consistent photo evidence, structured findings, and a format that supports pre- and post-mitigation reviews. By enabling hassle-free self-inspections, the experience helps reduce inspection timelines from weeks to days, giving carriers and policyholders faster feedback loops while preserving a clear audit trail. </p>
                        <p className="modalSubHeader">RESULTS</p>
                        <p>
                            FireBreak gives residents a credible, five-minute path from uncertainty to action: know your risk score, see exactly how to lower it—and by how much—and act on a small set of high-impact fixes first.
                        </p>
                        <p>
                            The illustrated plan makes it easy to coordinate with neighbors and community partners, while insurer-ready outputs streamline mitigation reviews and renewals. In short: a purpose-built tool that turns climate-driven risk into practical steps homeowners can take today—before the next wildfire. 
                        </p>
                    </div>
                    
                    {/* Mobile stacked screenshots */}
                    <div className="firebreakMobileScreenshots">
                        <img 
                            src={FirebreakScreenshot1} 
                            className="firebreakMobileScreenshot"
                            alt="firebreak app screenshot 1"
                        />
                        <img 
                            src={FirebreakScreenshot2} 
                            className="firebreakMobileScreenshot"
                            alt="firebreak app screenshot 2"
                        />
                        <img 
                            src={FirebreakScreenshot3} 
                            className="firebreakMobileScreenshot"
                            alt="firebreak app screenshot 3"
                        />
                    </div>
                </Col>
                <Col lg="6">
                    {/* Desktop graphics with absolute positioning */}
                    <div className="firebreakGraphics desktopGraphics">
                        <img
                            src={FirebreakScreenshot1}
                            className="firebreakScreenshot1"
                            alt="firebreak app screenshot 1"
                        />
                        <img
                            src={FirebreakScreenshot3}
                            className="firebreakScreenshot3"
                            alt="firebreak app screenshot 3"
                        />
                        <img
                            src={FirebreakScreenshot2}
                            className="firebreakScreenshot2"
                            alt="firebreak app screenshot 2"
                        />
                        <img
                            src={FirebreakLogo}
                            className="firebreakLogo"
                            alt="firebreak logo"
                        />
                    </div>

                    {/* Tablet graphics with flexbox layout */}
                    <div className="firebreakTabletGraphics">
                        <div className="firebreakTabletRow">
                            <img
                                src={FirebreakScreenshot1}
                                className="firebreakTabletScreenshot"
                                alt="firebreak app screenshot 1"
                            />
                            <div className="firebreakTabletColumn">
                                <img
                                    src={FirebreakLogo}
                                    className="firebreakTabletLogo"
                                    alt="firebreak logo"
                                />
                                <img
                                    src={FirebreakScreenshot2}
                                    className="firebreakTabletScreenshot"
                                    alt="firebreak app screenshot 2"
                                />
                            </div>
                            <img
                                src={FirebreakScreenshot3}
                                className="firebreakTabletScreenshot"
                                alt="firebreak app screenshot 3"
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default Firebreak;